import logo from "./logo.svg";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Dashboard from "./pages/dashboard/dashboard.jsx";
import Login from "./pages/login/Login.jsx";
import Home from "./pages/home/home";

import Barbers from "./pages/barber/barbers.jsx";
import BarberAvailabilty from "./pages/barber/barber-availability/barberAvailabilty.jsx";
import BarberUnavailability from "./pages/barber/barber-unavailabilty/BarberaUnavailability.jsx";

import AppointmentsManagement from "./pages/appointment/appointments-Management/appointments-Management.jsx";
import Services from "./pages/services/services.jsx";
import ServiceGroups from "./pages/services/service-group/serviceGroups.jsx";
import BarberService from "./pages/services/BarberService/barberServices.jsx";

import AddAppointment from "./pages/appointment/add-appointment/add-appointment.jsx";

import Customers from "./pages/customers/customers.jsx";
import AddCustomer from "./pages/customers/add-customer.jsx";

import Configuration from "./pages/configurations/configurations.jsx";
import Calendar from "./pages/calendar/calendar.jsx";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<Home />}>
              <Route index element={<Dashboard />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="staff" element={<Barbers />} />
              <Route path="staff-availabilty" element={<BarberAvailabilty />} />
              <Route
                path="staff-unavailabilty"
                element={<BarberUnavailability />}
              />
              <Route
                path="appointments-manegment"
                element={<AppointmentsManagement />}
              />
              <Route path="services" element={<Services />} />
              <Route path="service-groups" element={<ServiceGroups />} />
              <Route path="staff-service" element={<BarberService />} />

              <Route path="customers" element={<Customers />} />
              <Route path="add-customer" element={<AddCustomer />} />
              <Route path="add-appointment" element={<AddAppointment />} />
              <Route path="calendar" element={<Calendar />} />
              <Route path="settings" element={<Configuration />} />
            </Route>
          </Route>
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
